import { useState } from 'react';

export const actionTypes = {
    INCREMENT: 'INCREMENT',
    DECREMENT: 'DECREMENT',
    MANUAL: 'MANUAL'
};

export const INITIAL_STATE = { counter: 0 };

export const counterReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.INCREMENT:
            return { ...state, counter: state.counter + 1 };
        case actionTypes.DECREMENT:
            return { ...state, counter: state.counter - 1 };
        case actionTypes.MANUAL:
            return { ...state, counter: action.counter };
        default:
            return state;
    }
};

export const useCounterReducer = (counterReducer, initialState) => {

    const [ counter, setCounter ] = useState(initialState);

    const {
        minCounter,
        maxCounter
    } = counter;

    function dispatch(action) {
        const {
            type,
            counter: newCounter
        } = action;

        let updatedCount;

        if(type === actionTypes.MANUAL) {
            if(!newCounter.match(/^\s?[0-9]*$/)) {
                return;
            } else if(+newCounter < minCounter || +newCounter > maxCounter) {
                return;
            } else {
                updatedCount = counterReducer(counter, { ...action, counter: +newCounter });
            }
        } else {
            updatedCount = counterReducer(counter, action);
        }

        setCounter(updatedCount);
    }

    return [ counter, dispatch ];
};